export const FETCH_MACHINES_REQUEST = 'FETCH_MACHINES_REQUEST';
export const FETCH_MACHINES_SUCCESS = 'FETCH_MACHINES_SUCCESS';
export const FETCH_MACHINES_FAILURE = 'FETCH_MACHINES_FAILURE';

export const FETCH_MACHINE_REQUEST = 'FETCH_MACHINE_REQUEST';
export const FETCH_MACHINE_SUCCESS = 'FETCH_MACHINE_SUCCESS';
export const FETCH_MACHINE_FAILURE = 'FETCH_MACHINE_FAILURE';

export const CREATE_MACHINE_REQUEST = 'CREATE_MACHINE_REQUEST';
export const CREATE_MACHINE_SUCCESS = 'CREATE_MACHINE_SUCCESS';
export const CREATE_MACHINE_FAILURE = 'CREATE_MACHINE_FAILURE';

export const UPDATE_MACHINE_REQUEST = 'UPDATE_MACHINE_REQUEST';
export const UPDATE_MACHINE_SUCCESS = 'UPDATE_MACHINE_SUCCESS';
export const UPDATE_MACHINE_FAILURE = 'UPDATE_MACHINE_FAILURE';

export const DELETE_MACHINE_REQUEST = 'DELETE_MACHINE_REQUEST';
export const DELETE_MACHINE_SUCCESS = 'DELETE_MACHINE_SUCCESS';
export const DELETE_MACHINE_FAILURE = 'DELETE_MACHINE_FAILURE';

export const ACTIVE_MACHINE_REQUEST = 'ACTIVE_MACHINE_REQUEST';
export const ACTIVE_MACHINE_SUCCESS = 'ACTIVE_MACHINE_SUCCESS';
export const ACTIVE_MACHINE_FAILURE = 'ACTIVE_MACHINE_FAILURE';

export const FREE_MACHINES_REQUEST = 'FREE_MACHINES_REQUEST';
export const FREE_MACHINES_SUCCESS = 'FREE_MACHINES_SUCCESS';
export const FREE_MACHINES_FAILURE = 'FREE_MACHINES_FAILURE';
